import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import GenericModal from '../GenericModal';
import StatusBar from '../../StatusIndicators/StatusBar';

const ModalStyled = styled(GenericModal)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  // align-items: center;
  width: 500px;
  height: auto;
  padding: 30px 10px 20px;
`

const Header = styled.div`
  font-size: 22px;
  font-weight: 600;
`
const SubHeader = styled.div`
  font-size: 12px;
`

const StatusModal = ({
  value,
  header,
  subheader,
  children,
  ...other
}) => {

  return (
    <ModalStyled {...other}>
      <Header>{header}</Header>
      <SubHeader>{subheader}</SubHeader>
      <StatusBar
        primary={value.primaryStatus}
        statuses={value.statuses}
      />
    </ModalStyled>
  );
}

StatusModal.propTypes = {
  header: PropTypes.string,
  subheader: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  value: PropTypes.object,
};

StatusModal.defaultProps = {
}

export default StatusModal;
